import { createContext, useContext } from "react";

import type { UpgradePlan } from "./types";

export interface UpgradeFlowProps {
  handleOnSuccess: () => void;
  modal: { hide: () => void };
  subheading?: string;
  successButtonLabel?: string;
}

const UpgradeFlowShellContext = createContext<UpgradeFlowProps | null>(null);
UpgradeFlowShellContext.displayName = "UpgradeFlowShellContext";

export const UpgradeFlowShellContextProvider = UpgradeFlowShellContext.Provider;

export const useUpgradeFlowShellContext = (): UpgradeFlowProps => {
  const context = useContext(UpgradeFlowShellContext);
  if (!context) {
    throw new Error(
      "useUpgradeFlowShellContext must be used within UpgradeFlowShellContextProvider",
    );
  }
  return context;
};

export interface UpgradeFlowFormContextValue {
  handleChangePlan: (plan: UpgradePlan) => void;
  loadingMessage: { subtitle: string; title: string };
  onSubmitHandler: () => void;
  onSubmitHandlerPlanDetails: () => void;
}

const UpgradeFlowFormContext =
  createContext<UpgradeFlowFormContextValue | null>(null);
UpgradeFlowFormContext.displayName = "UpgradeFlowFormContext";

export const UpgradeFlowFormContextProvider = UpgradeFlowFormContext.Provider;

export const useUpgradeFlowFormContext = (): UpgradeFlowFormContextValue => {
  const context = useContext(UpgradeFlowFormContext);
  if (!context) {
    throw new Error(
      "useUpgradeFlowFormContext must be used within UpgradeFlowFormContextProvider",
    );
  }
  return context;
};
